import { ORDER_LAB_TEST_CART } from './constants';
import { FareDict } from './createLabTestCart';
import { fetchWithRefreshWithoutRetry } from './fetchWithRefresh';
import { Address, Cart, CollectionSlot, CustomerDetails, Data } from './getLabTestsOrder';

export interface Request {
    order_id?: string;
    patientid: string;
    pxid: string;
    collection_date: string;
    collection_slot: CollectionSlot;
    address: Address;
    customerDetails: CustomerDetails;
    paymode: string;
    vendor: string;
    vendor_id: string;
    discount: number;
    booking_price: number;
    pincode: string;
    vendor_error?: string;
    cart: Cart[];
    extra_charges: {
        [k: string]: number;
    };
    placedByDoctor?: boolean;
    sample_collection_type?: string;
    fare_dict: FareDict;
    members: AdditionalMember[];
}

export interface AdditionalMember {
    patient_id: string;
    name: string;
    mobile: string;
}

export interface Response {
    success: boolean;
    order: Data[];
    update_statuses: UpdateStatuses;
    error?: string;
}

export interface UpdateStatuses {
    [k: string]: {
        status: string;
        message: string;
    };
}

export default (docid: string, request: Request): Promise<Response> => {
    return fetchWithRefreshWithoutRetry(ORDER_LAB_TEST_CART(docid), {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
